module.exports = __webpack_public_path__ + "img/9788996147442.ca577f99.jpg";